<template>
    <div class="widget tasklist">
        <div class="title">任务列表<span style="font-size: 12px;color: red;">&emsp;任务进行中请勿刷新页面</span></div>
        <div class="list" v-show="taskInfo" style="max-height: 300px;overflow: auto;">
            <div v-for="(item, index) in taskInfo" class="list-item">
                <div v-if="item">
                    <el-row>
                        <el-col :span="12" style="text-align: left;">{{ item.name }}</el-col>

                        <el-col :span="12">
                            <span :style="item.status == 'ERROR' ? { color: 'red' } : ''">{{
                                statusToChinese(item.status)
                                }}</span>&emsp;
                            <a :href="baseURL + item.url" v-if="item.status == 'FINISHED'">下载</a>
                            &emsp;
                            <a v-if="item.status == 'FINISHED'" @click="goToEdit(item.url,item.maxX,item.maxY,item.minX,item.minY,item.zoom)" href="#">叠加网格</a>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-progress :percentage="Math.floor((item.process / item.total) * 100)"
                                color="greenyellow">
                            </el-progress>
                        </el-col>
                    </el-row>
                    <el-row style="line-height: 20px;font-size: 12px;color: black;">
                        <el-col :span="16" style="text-align: left;"> {{ item.process }} /{{ item.total }}</el-col>
                        <el-col :span="8" v-if="item.status != 'FINISHED' && item.status != 'ERROR'">
                            {{ coastTime(item.startTime) }}
                        </el-col>
                    </el-row>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { ps } from '../../util/request'
import util from '../../util/commonUtil'
import { baseURL } from '../../util/http'

export default {
    data() {
        return {
            name: 'tasklist',
            showDialog: false,
            taskInfo: [],
            timer: null,
            baseURL: baseURL + '/user/down?name='
        };
    },
    watch: {

    },
    computed: {
        taskList() {
            return this.$store.state.taskList
        },
    },
    methods: {
        goToEdit(imageFileName,maxX,maxY,minX,minY,zoom) {
            // 打开新标签页并跳转到新组件的路由
            const routeData = this.$router.resolve({
                name: 'edit',
                query: {
                    imageFileName,maxX,maxY,minX,minY,zoom
                }
            });
            window.open(routeData.href, '_blank');
        },
        coastTime(startTime) {
            return util.timeStampFormatter(new Date().getTime() - startTime)
        },
        statusToChinese(code) {
            switch (code) {
                case 'START':
                    return '已启动';
                case 'RUNNING':
                    return '进行中';
                case 'DOWNLOADING':
                    return '下载中';
                case 'SPLICING':
                    return '拼接中';
                case 'FINISHED':
                    return '完成';
                case 'ERROR':
                    return '错误';
            }
        }
    },
    mounted() {
        let list = this.taskList
        if (this.timer) {
            clearTimeout(this.timer)
        }
        this.timer = setInterval(() => {
            if (list.length > 0) {
                ps({ list }).then(res => {
                    if (res.resultCode == 1) {
                        this.taskInfo = res.result                                   
                    } else
                        this.$message.error(res.info)
                })
            }
        }, 1000)
    },
    destroyed() {
        if (this.timer) {
            clearTimeout(this.timer)
        }
        this.$store.commit('clearTask')
    }
};
</script>

<style scoped>
.tasklist {
    top: 100px;
    left: 20px;
    width: 320px;

}

.title {
    background-color: white;
    padding: 10px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    text-align: left;
    color: black;
}

.list {
    max-height: 400px;
    background-color: #ffffff88;
    padding: 10px;
}

.list-item {
    color: black;
    font-size: 12px;
    font-weight: bold;
    border-bottom: 1px solid gray;
}

a {
    color: #0066cc;
}

/* 需要使用深度修改器修改样式 */

/deep/ .el-progress__text {
    color: #0066cc !important;
    font-size: 12px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/main/TaskList.vue